<h1 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">{{ title }}</span>
    @if (!Data.hideHeaderClose) {
        <button type="button" mat-icon-button class="treeslo-modal-header__close" mat-dialog-close
            aria-label="Close">
            <mat-icon>close</mat-icon>
        </button>
    }
</h1>
<mat-dialog-content>
    <p>{{message}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button *ngIf="!Data.clearButtonClose" mat-button type="button" mat-dialog-close>Cancel</button>
        <button color="warn" mat-button type="button" [mat-dialog-close]="true" cdkFocusInitial>{{ okAction }}</button>
    </div>
</mat-dialog-actions>